// extracted by mini-css-extract-plugin
export default {"formTitle":"FormHeader_formTitle__Rz81T","alert":"FormHeader_alert__1YvKh","alertDanger":"FormHeader_alertDanger__EdSNK"};